/**
 * pressBoxFormat.js — 2026-10-19. Little formatters the Press Box pages
 * share: game times in the team's chosen clock (12-hour by default), and
 * which part of the season a date falls in (pre-season / regular season /
 * playoffs, set in Site & Settings — league feeds don't carry this).
 */

/** '19:05' → '7:05 PM' (12h, the default) or '19:05' (24h). */
export function fmtGameTime(hhmm, format = '12h') {
  if (!hhmm) return '';
  const m = String(hhmm).match(/^(\d{1,2}):(\d{2})/);
  if (!m) return hhmm;
  if (format === '24h') return `${m[1].padStart(2, '0')}:${m[2]}`;
  let h = Number(m[1]);
  const suffix = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${h}:${m[2]} ${suffix}`;
}

export const PHASE_LABELS = Object.freeze({
  preseason: 'Pre-season',
  regular: 'Regular season',
  playoffs: 'Playoffs',
});

/** Which configured phase a YYYY-MM-DD date falls in (null when none match). */
export function phaseOf(date, phases) {
  if (!date || !phases) return null;
  for (const k of ['preseason', 'regular', 'playoffs']) {
    const r = phases[k];
    if (!r) continue;
    if ((!r.from || date >= r.from) && (!r.to || date <= r.to) && (r.from || r.to)) return k;
  }
  return null;
}

/** A Google Maps link for an arena (the feed's address when we have it). */
export const mapsUrl = (q) => (q ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}` : null);
